import React from 'react';
import savedIcon from '../Icons/saved1.png';
import saveIcon from '../Icons/save.png';
import camaraIcon from '../Icons/camara.jpg';
import {useNavigate} from 'react-router-dom';
import './RecipeSearchCard.css';

const RecipeSearchCard = ({recipe, isFavorite, handleAddToFavorites, handleRemoveFromFavorites}) => {
  const navigate = useNavigate();

  const handleSave = (e) => {
    e.stopPropagation();
    if (isFavorite) {
      handleRemoveFromFavorites(recipe);
   } else {
      handleAddToFavorites(recipe);
   }
 };

  // Lógica para mostrar la fuente
  let fuenteDisplay = recipe.fuente || 'Fuente desconocida';
  if (
    (recipe.fuente === 'usuario' || recipe.fuente === 'CookyChat') &&
    recipe.userName
  ) {
    fuenteDisplay = recipe.userName;
 }

 const formatIngredient = (ing) => {
  if (!ing) return '';
  if (typeof ing === 'string') return ing;
  const nombre = ing.nombre || '';
  const cantidad = (ing.cantidad !== undefined && ing.cantidad !== null) ? String(ing.cantidad).trim() : '';
  const unidad = ing.unidad ? String(ing.unidad).trim() : '';
  const cantidadParte = cantidad && cantidad !== '0' ? cantidad : '';
  const unidadParte = unidad ? unidad : '';
  if (cantidadParte || unidadParte) {
    return `${[cantidadParte, unidadParte].filter(Boolean).join(' ')} de ${nombre}`.trim();
  }
  return nombre;
 };

 return (
   <div
     className="recipe-card recipe-search-card"
     onClick={() => {
       if (recipe.urlOrigen && recipe.urlOrigen.includes('directoalpaladar.com')) {
         window.open(recipe.urlOrigen, '_blank');
      } else {
         navigate(`/recipe/${recipe.objectID || recipe.id}`);
      }
     }}
   >
     <span className="recipe-source">
       {fuenteDisplay}
     </span>
     <h3 className="recipe-title">{recipe.nombre}</h3>
     <div className="recipe-image-wrapper">
       <img
         src={recipe.imagen ? recipe.imagen : camaraIcon}
         alt={recipe.nombre}
         className="recipe-image-centered"
       />
     </div>
     <p><strong>Ingredientes:</strong></p>
     <ul>
       {Array.isArray(recipe.ingredientes) && recipe.ingredientes.length > 0 ? (
         recipe.ingredientes.map((ing, idx) =>
           <li key={idx}>{formatIngredient(ing)}</li>
         )
       ) : (
         <li>No hay ingredientes.</li>
       )}
     </ul>
     <div className="icon-row">
      <img
        src={isFavorite ? savedIcon : saveIcon}
        alt={isFavorite ? "Guardada" : "Guardar"}
        className={isFavorite ? "saved-icon" : "save-icon"}
        onClick={handleSave}
      />
    </div>
   </div>
 );
};

export default RecipeSearchCard;